// extracted by mini-css-extract-plugin
export default {"wrapper":"MemoysOr","blockModalButton":"rtpSPRoR","textHeader":"Ik64Omv0","textArea":"BLslwoAe","textAreaField":"fFNtdEqy","button":"VsVVdyIM"};